import { FieldPath, UseFormSetError, FieldValues } from 'react-hook-form';

import { scrollToFirstError } from '../view/scroll';

const applyServerValidation = <TFormValues extends FieldValues>(
  setError: UseFormSetError<TFormValues>,
  errors?: { [key in keyof TFormValues]?: string[] | undefined },
) => {
  if (!errors) {
    return;
  }

  Object.entries(errors).forEach(([key, value]) => {
    const fieldName = key as FieldPath<TFormValues>;
    const fieldErrors = value as string[];

    if (fieldErrors?.length) {
      setError(fieldName, {
        message: fieldErrors[0],
        type: 'server validations',
      });
    }
  });

  scrollToFirstError();
};

export { applyServerValidation };
